<script>
import { RepositoryFactory } from "../../api/RepositoryFactory";
const UserCalls = RepositoryFactory.get("user");
export default {
  created() {
    const appLoading = document.getElementById("loading-bg");
    appLoading.style.display = "block";
    const code = this.$route.params["code"];
    UserCalls.confirmUserByCode(code).then(({ data }) => {
      localStorage.setItem("token", JSON.stringify(data));
    }).then(() => {
         this.$router.push({name: 'home', params:{ confirm: true}})
    }).catch(err =>  {
      this.$router.push({
        name: "pageLogin",
        params: {
          err: 'badCode'
        }
      })
    })
  }
};
</script>

<style>
</style>
